<template>
    <div class="selector-container">
        <h5 class="selector-title">{{ props.heading }}</h5>
        <div class="scroll-container">
            <div
                v-for="dashboard in orderedDashboards"
                class="dashboard-card"
                :key="dashboard.id"
                :id="dashboard.id"
                :class="{ selected: selectedDashboards[dashboard.id] }"
                @click="selectDashboard(dashboard)"
                @keydown="selectDashboard(dashboard)"
            >
                <div class="flex-row-with-gap">
                    <icofont-icon
                        :icon="dashboard.data.icon ?? ''"
                        :background-colour="dashboard.data.colour ?? ''"
                    />
                    <span>{{ dashboard.data.name }}</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import { computed, ref } from 'vue';
import { IDashboard } from '@/interfaces/powerMarkets/dashboard/IDashboard.ts';
import { IPageData } from '@/interfaces/general/IPageData.ts';
import { useUserSettingsStore } from '@/stores/userSettingsStore.ts';
import IcofontIcon from '@/components/powerMarkets/common/IcofontIcon.vue';

const emit = defineEmits<{
    'update:selected-dashboards': [Array<string>];
}>();

const props = withDefaults(defineProps<{
    heading?: string;
}>(), {
    heading: 'Clone to dashboards',
});

const selectedDashboards = ref<Record<string, boolean>>({});

const dashboardIds = computed(() => Object.keys(selectedDashboards.value).filter(id => selectedDashboards.value[id]));

const userSettingsStore = useUserSettingsStore();

function selectDashboard (dashboard: IPageData<IDashboard>): void {
    selectedDashboards.value[dashboard.id] = !selectedDashboards.value[dashboard.id];
    emit('update:selected-dashboards', dashboardIds.value);
}

const orderedDashboards = computed<Array<IPageData<IDashboard>>>(() => {
    const dashboards = userSettingsStore.userSettings.dashboardsWithOrder;
    return dashboards.order.data.map(id => dashboards.objectsToStore[id]).filter(Boolean);
});

</script>

<style lang="scss" scoped>
.selector-container{
    display: flex;
    flex-direction: column;
    min-width: 350px;
    height: 100%;
    min-height: 0;

    .scroll-container {
        flex: 1;
        min-height: 0;
        max-height: none;
    }

    &.module-footer-dashboard-selector {
        height: auto;
        max-height: min(40vh, 300px);

        .scroll-container {
            flex: 0 1 auto;
            min-height: 0;
            max-height: none;
            overflow-y: auto;
        }
    }

    .selector-title{
        padding: var(--largeSpacing) var(--defaultSpacing) 0;
    }
}
.scroll-container {
    max-height: 300px;
    overflow: auto;
    display: flex;
    flex-direction: column;
    gap: var(--defaultSpacing);
    padding: var(--largeSpacing) var(--defaultSpacing);
}

</style>
